import moment from "moment";
import React, { useEffect, useState } from "react"
import Shimmer from "../common/Shimmer";
import constant from "../../constant";

import { addDetail, getList } from "../../action/ChatAction";
import { getStorage } from "../../utils";

export function CustomChatButton(props: { id: any, css: any, children: any, socket: any }) {
    const { id, css, children, socket } = props;
    const [showModal, setShowModal] = useState(false);

    const onShowModal = () => {
        setShowModal(true);
    }

    const onHideModal = () => {
        debugger;
        setShowModal(false);
    }

    return (
        <React.Fragment>
            <div>
                <div className="chat-button-container">
                    {
                        showModal && <ChatForm id={id} onHideModal={onHideModal} socket={socket} />
                    }
                </div>
            </div>
            <button type="button" className={css} onClick={onShowModal}>
                {children}
            </button>
        </React.Fragment >
    )
}

function ChatButton() {
    const [showModal, setShowModal] = useState(false);

    const onToggleModal = () => {
        setShowModal(!showModal);
    }

    const onHideModal = () => {
        setShowModal(false);
    }

    return (
        <React.Fragment>
            <div className="chat-button-container">
                {
                    showModal && <ChatForm onHideModal={onHideModal} />
                }
                <button type="button" className="chat-button" onClick={onToggleModal}>
                    {
                        showModal
                            ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" className="w-1 h-1">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" className="w-1 h-1">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
                            </svg>
                    }
                </button>
            </div>
        </React.Fragment >
    )
}

function ChatForm(props: any) {
    const { onHideModal, list, id, socket } = props;

    const ud = getStorage(constant.key.userDetail);
    const [message, setMessage] = useState('');
    const [messageList, setMessageList]: any = useState(list);
    const [showLoader, setShowLoader] = useState(false);

    const onAddDetail = (e: any) => {
        e.preventDefault();
        if (message.trim().length > 0) {
            setShowLoader(true);
            const model = {
                message,
                loanDetailId: id,
                customerId: ud.id
            }
            addDetail(model).then((res: any) => {
                setShowLoader(false);

                if (res.error) {

                } else {
                    onBroadcastMessageSent();
                    setMessage('');
                    setMessageList([res.result, ...messageList]);
                }
            })
        }
    }

    const onBroadcastMessageSent = () => {
        const { id, socket } = props;
        const customer = true;
        socket.emit('client broardcast message sent', id, customer);
    }

    const onBroadcastMessageRead = () => {
        debugger;
        const customer = true;
        socket.emit('client broardcast message read', id, customer);
    }

    useEffect(() => {
        onLoadList();
        socket.on("client message update received", (loanDetailId: any, customer: boolean) => {
            if (id === loanDetailId && customer === true) {
                onLoadList();
            }
        });
    }, [])

    const onLoadList = () => {
        const employeeView = false;
        getList(id, employeeView).then((res: any) => {
            if (res.error) {

            } else {
                setMessageList(res.result);
                onBroadcastMessageRead();
            }
        })
    }

    return (
        <div className="chat-modal-container">
            <div className="chat-modal-header py-2">
                <div className="row">
                    <div className="col">
                        <b className="">Chat Support</b>
                    </div>
                    <div className="col-auto">
                        <button className="btn btn-link p-0" type="button" onClick={onHideModal}>
                            <svg style={{ height: '1rem', width: '1rem' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div className="chat-modal-body py-3">
                {messageList === undefined && <Shimmer />}
                {messageList !== undefined && messageList.length === 0 && <div className="text-center">No Message Found</div>}
                {messageList !== undefined && messageList.map((item: any, index: number) => {
                    let css = "p-3 bg-light border-eee br-3 mt-3 w-90";
                    const myMessage = item.customerId !== null;
                    if (myMessage) {
                        css = "p-3 br-3 mt-3 w-90 bg-secondary text-white float-right";
                    }

                    return <div>
                        <div className={css}>
                            <div dangerouslySetInnerHTML={{ __html: item.message }} />
                            <div className="text-right">
                                <div>
                                    <small>{item.customerName}</small>
                                    <small>{item.employeeName}</small>
                                </div>
                                <small>{moment(item.createdOn).format(constant.formatting.usDateTimeFormat)}</small>
                            </div>

                        </div>
                    </div>
                })}
            </div>
            <div className="chat-modal-footer">
                <form onSubmit={onAddDetail}>
                    <div className="input-group flex-nowrap">
                        <input
                            disabled={showLoader}
                            onChange={(e: any) => setMessage(e.target.value)}
                            placeholder="Press enter to post a message"
                            type="text"
                            className="form-control br-3"
                            value={message}
                        />
                        <div className="input-group-append">
                            <button
                                disabled={showLoader}
                                style={{
                                    borderRadius: '0 3px 3px 0px'
                                }} type="submit" className="btn btn-primary">Send</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ChatButton;